import { Link } from "react-router-dom";
import { Newspaper, ArrowRight } from "lucide-react";
import { LOGO_URL } from "@/data/content";
import { Reveal, GoldLine } from "@/components/Reveal";

export default function Magazine() {
  return (
    <main data-testid="magazine-page" className="bg-[#080808] min-h-screen flex items-center justify-center px-6">
      <div className="text-center max-w-xl py-32">
        <Reveal>
          <img src={LOGO_URL} alt="Billions Group" className="h-16 w-auto mx-auto mb-10" />
        </Reveal>
        <Reveal delay={0.1}>
          <div className="w-16 h-16 mx-auto border border-[#C6A45D]/40 flex items-center justify-center mb-8">
            <Newspaper size={22} className="text-[#C6A45D]" />
          </div>
        </Reveal>
        <Reveal delay={0.15}>
          <p className="eyebrow mb-5">Billions Group</p>
          <h1 className="font-display text-5xl sm:text-6xl font-light text-[#F5F2EB] tracking-tight">
            Maga<span className="gold-gradient-text italic">zine.</span>
          </h1>
        </Reveal>
        <GoldLine className="mt-8 w-24 mx-auto" />
        <Reveal delay={0.25}>
          <p className="mt-4 text-xs tracking-[0.4em] uppercase text-[#C6A45D]">
            Coming Soon
          </p>
        </Reveal>
        <Reveal delay={0.3}>
          <div className="mt-12 relative inline-block">
            <div className="absolute -inset-3 border border-[#C6A45D]/30 pointer-events-none" />
            <img
              src="/assets/magazine_cover.jpeg"
              alt="Billions Magazine — Giugno 2026"
              data-testid="magazine-cover"
              className="w-72 sm:w-80 h-auto shadow-2xl shadow-black"
            />
          </div>
        </Reveal>
        <Reveal delay={0.3}>
          <p className="mt-8 text-[#A5A5A5] font-light leading-relaxed">
            Storie, progetti e visioni dal mondo Billions Group: le nostre
            business unit, i partner e le eccellenze che stiamo costruendo.
            Il Magazine è in arrivo.
          </p>
        </Reveal>
        <Reveal delay={0.4}>
          <Link
            to="/contatti"
            data-testid="magazine-cta-contatti"
            className="group mt-10 inline-flex items-center gap-3 px-10 py-4 border border-[#C6A45D]/60 text-[#C6A45D] text-xs tracking-[0.25em] uppercase hover:bg-[#C6A45D] hover:text-[#080808] transition-colors duration-300"
          >
            Restiamo in contatto
            <ArrowRight size={15} className="transition-transform duration-300 group-hover:translate-x-1" />
          </Link>
        </Reveal>
      </div>
    </main>
  );
}
